var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-center py-10"},[_c('h1',{staticClass:"mb-5"},[_vm._v("Link non valido")]),_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":{ name: 'checkins-list'}}},[_vm._v("Vai ai tuoi eventi")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }